import { zipSync, strToU8 } from 'fflate';
import { PrintJob } from './types';
import { encodeBinaryStl } from './stl';

export function partFileName(part: { id: string; kind: string }): string {
  return `${part.id}.stl`;
}

/** Build a ZIP of all print parts plus a small manifest. */
export function buildPrintZip(job: PrintJob, coasterName: string): Uint8Array {
  const files: Record<string, Uint8Array> = {};
  const manifest = {
    name: coasterName,
    chunkSizeMm: job.settings.chunkSizeMm,
    separateSupport: job.settings.separateSupport,
    splitAtToothBottom: job.settings.splitAtToothBottom,
    printScale: '1:100',
    cuts: job.cuts,
    warnings: job.warnings,
    parts: job.parts.map((p) => ({
      id: p.id,
      kind: p.kind,
      s0: p.s0,
      s1: p.s1,
      obbMm: p.obbMm,
      oversized: p.oversized,
      fixed: p.fixed,
      fixWarning: p.fixWarning,
      file: p.kind === 'track' ? `track/${partFileName(p)}` : `supports/${partFileName(p)}`,
    })),
  };
  files['manifest.json'] = strToU8(JSON.stringify(manifest, null, 2));
  files['print-log.txt'] = strToU8((job.log ?? []).join('\n') + '\n');
  files['README.txt'] = strToU8(
    [
      `RCSimFable print export: ${coasterName}`,
      `Scale: 1:100 (coordinates in STL are millimetres)`,
      `Build cube: ${job.settings.chunkSizeMm} mm`,
      `SeparateSupport: ${job.settings.separateSupport}`,
      `Split at nearest tooth bottom: ${job.settings.splitAtToothBottom}`,
      '',
      'Prototype meshes solidified with Manifold boolean union (STL fixer) for slicer-ready solids.',
      'Joint clearance: 0.25 mm at print scale. Pin goes into the sleeve of the next part.',
      `Parts solidified: ${job.parts.filter((p) => p.fixed).length}/${job.parts.length}`,
      '',
      ...job.warnings.map((w) => `Warning: ${w}`),
      '',
      'See print-log.txt for full generation diagnostics.',
    ].join('\n'),
  );

  for (const part of job.parts) {
    const folder = part.kind === 'track' ? 'track' : 'supports';
    files[`${folder}/${partFileName(part)}`] = encodeBinaryStl(part.mesh, part.id);
  }

  return zipSync(files, { level: 6 });
}
